import { render, staticRenderFns } from "./SampleAccordion.vue?vue&type=template&id=7496546e&"
import script from "./SampleAccordion.vue?vue&type=script&lang=ts&"
export * from "./SampleAccordion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports